import { render, staticRenderFns } from "./tiezi.vue?vue&type=template&id=eb766bfa&scoped=true"
import script from "./tiezi.vue?vue&type=script&lang=js"
export * from "./tiezi.vue?vue&type=script&lang=js"
import style0 from "./tiezi.vue?vue&type=style&index=0&id=eb766bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb766bfa",
  null
  
)

export default component.exports